import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between flex-wrap pb-4 px-4 bg-white rounded-4 tw-ml-[24px] tw-mr-[24px]" }
const _hoisted_2 = { class: "w-50 px-4" }
const _hoisted_3 = { class: "d-flex justify-content-between pb-4 px-1 gap-5 bg-white rounded-4 tw-items-center tw-mt-[30px]" }
const _hoisted_4 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "4"
    }, "RESIDENTIAL")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tr", { class: "data" }, [
  /*#__PURE__*/_createElementVNode("td", null, "Years"),
  /*#__PURE__*/_createElementVNode("td", null, "Down Payment"),
  /*#__PURE__*/_createElementVNode("td", null, "Interest Rate"),
  /*#__PURE__*/_createElementVNode("td", null, "Remove")
], -1)
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = { class: "w-50 px-4" }
const _hoisted_16 = { class: "pb-3 tw-mt-[30px]" }
const _hoisted_17 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "4"
    }, "INVESTMENT")
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", { class: "data" }, [
  /*#__PURE__*/_createElementVNode("td", null, "Years"),
  /*#__PURE__*/_createElementVNode("td", null, "Down Payment"),
  /*#__PURE__*/_createElementVNode("td", null, "Interest Rate"),
  /*#__PURE__*/_createElementVNode("td", null, "Remove")
], -1)
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_28 = { class: "w-100 mt-4" }
const _hoisted_29 = ["onClick"]

import axios from "axios";
import Swal from "sweetalert2";
import { environment } from "@/environment";
import { ref, toRefs, watch } from "vue";
import UnderwritingCommission from "./Property/UnderwritingCommission.vue";

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'ForeignTables',
  props: {
    userID: {
        type: Number,
        default: null,
    },
},
  emits: ["updateResidentialData"],
  setup(__props, { emit }) {

const props = __props;


const { userID } = toRefs(props);

// Variables
const url = environment.URL_API;
const loading = ref(false);

const createEmptyResidential = () => ({
    ID: null,
    user_id: userID.value,
    type: "residential",
    years: 0,
    down_payment: 0,
    interest_rate: 0,
});

const createEmptyInvestment = () => ({
    ID: null,
    user_id: userID.value,
    type: "investment",
    years: 0,
    down_payment: 0,
    interest_rate: 0,
});

const dataUnderwritingCommission = ref({
    ID: null,
    user_id: userID.value,
    type: "Foreign",
    mlo_commission: 0,
});

const residentialTable = ref([createEmptyResidential()]);
const investmentTable = ref([createEmptyInvestment()]);



// Watch for changes in residential data
watch(
    residentialTable,
    (newValue) => {
        const residentialData = newValue.map((row) => ({
            interestRate: row.interest_rate,
            downPayment: row.down_payment,
        }));
        emit("updateResidentialData", residentialData);
    },
    { deep: true }
);

// Functions
const getTablesData = async () => {
    loading.value = true;
    try {
        const response = await axios.get(`${url}tables/foreign?user_id=${userID.value}`);

        if (!response.data.error && response.data.Foreign) {
            residentialTable.value = response.data.Foreign.filter(
                (data) => data.type.toLowerCase() === "residential"
            ) || [createEmptyResidential()];
            
            investmentTable.value = response.data.Foreign.filter(
                (data) => data.type.toLowerCase() === "investment"
            ) || [createEmptyInvestment()];

            dataUnderwritingCommission.value = response.data.UnderwritingCommission || {
                ID: null,
                user_id: userID.value,
                type: "Foreign",
                mlo_commission: 0,
            };
            console.log()
        } else {
            console.error(response.data.message);
        }
    } catch (error) {
        Swal.fire("Error", "Failed to fetch table data", "error");
    } finally {
        loading.value = false;
    }
};

const addResidential = () => {
    residentialTable.value.push(createEmptyResidential());
};

const addInvestment = () => {
    investmentTable.value.push(createEmptyInvestment());
};

const removeResidential = async (index, ID) => {
    residentialTable.value.splice(index, 1);
    const response = await axios(`${url}tables/foreign`, {
        method: "DELETE",
        data: { ID },
    });
};

const removeInvesment = async (index, ID) => {
    investmentTable.value.splice(index, 1);
    const response = await axios(`${url}tables/foreign`, {
        method: "DELETE",
        data: { ID },
    });

};

const saveTablesData = async () => {
    loading.value = true;
    try {
        const response = await axios.post(`${url}tables/foreign`, {
            Foreign: [...residentialTable.value, ...investmentTable.value],
            UnderwritingCommission: dataUnderwritingCommission.value
        });

        if (response.data.error) {
            Swal.fire("Error", response.data.message, "error");
        } else {
            getTablesData();
            Swal.fire("Success", response.data.message, "success");
        }
    } catch (error) {
        Swal.fire("Error", "Failed to save table data", "error");
    } finally {
        loading.value = false;
    }
};

// Initialize data
getTablesData();

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Loader, { visible: loading.value }, null, 8, ["visible"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(residentialTable.value, (data, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "data",
                key: index
              }, [
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((data.years) = $event)
                  }, null, 8, _hoisted_7), [
                    [_vModelText, data.years]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((data.down_payment) = $event)
                  }, null, 8, _hoisted_8), [
                    [_vModelText, data.down_payment]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((data.interest_rate) = $event)
                  }, null, 8, _hoisted_9), [
                    [_vModelText, data.interest_rate]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (removeResidential(index, data.ID)), ["prevent"]),
                    class: "text-danger"
                  }, _hoisted_12, 8, _hoisted_10)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("button", {
        onClick: _withModifiers(addResidential, ["prevent"]),
        class: "btn btn-primary px-5"
      }, [
        _hoisted_14,
        _createTextVNode(" Add Residential ")
      ], 8, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("table", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("tbody", null, [
            _hoisted_19,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(investmentTable.value, (data, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "data",
                key: index
              }, [
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((data.years) = $event)
                  }, null, 8, _hoisted_20), [
                    [_vModelText, data.years]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((data.down_payment) = $event)
                  }, null, 8, _hoisted_21), [
                    [_vModelText, data.down_payment]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((data.interest_rate) = $event)
                  }, null, 8, _hoisted_22), [
                    [_vModelText, data.interest_rate]
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (removeInvesment(index, data.ID)), ["prevent"]),
                    class: "text-danger"
                  }, _hoisted_25, 8, _hoisted_23)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("button", {
        onClick: _withModifiers(addInvestment, ["prevent"]),
        class: "btn btn-primary px-5"
      }, [
        _hoisted_27,
        _createTextVNode(" Add Investment ")
      ], 8, _hoisted_26)
    ]),
    _createVNode(UnderwritingCommission, { data: dataUnderwritingCommission.value }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("button", {
        onClick: _withModifiers(saveTablesData, ["prevent"]),
        class: "btn btn-primary px-5"
      }, " Save ", 8, _hoisted_29)
    ])
  ]))
}
}

})